import "./App.css";
import { useState } from "react";
import data from "./data/staff.json";
import { CopyToClipboard } from "react-copy-to-clipboard";

// https://thegoldengates.carrd.co/#cafemenu

function App() {
  const [textToCopy, setTextToCopy] = useState(""); // The text you want to copy
  // <div>
  //       <textarea
  //         value={textToCopy}
  //         onChange={(e) => setTextToCopy(e.target.value)}
  //         placeholder="Type or paste text here..."
  //       />
  //       <CopyToClipboard text={textToCopy}>
  //         <button>Copy to Clipboard</button>
  //       </CopyToClipboard>
  //     </div>

  const [coffeeTea, setCoffeeTea] = useState([
    {
      name: "Hot Coffee",
      price: 2000,
      ordered: false,
      image: "./img/drink/hot-coffee.png",
      description: "Rich, bold flavor with notes of bitterness, acidity, and varying degrees of sweetness.",
      quantity: 0,
    },
    {
      name: "Iced Coffee",
      price: 2500,
      ordered: false,
      image: "./img/drink/iced-coffee.png",
      description:
        "Refreshing and smoother taste compared to hot coffee, with a milder bitterness and a slightly sweeter flavor profile",
      quantity: 0,
    },
    {
      name: "Espresso",
      price: 3000,
      ordered: false,
      image: "./img/drink/espresso.png",
      description: "Known for its bold flavor, intense aroma, and velvety texture",
      quantity: 0,
    },
    {
      name: "Matcha",
      price: 2500,
      ordered: false,
      image: "./img/drink/matcha-green-tea.png",
      description: "Matcha is known for its rich umami taste and is often described as both creamy and slightly bitter",
      quantity: 0,
    },
    {
      name: "Chai",
      price: 3350,
      ordered: false,
      image: "./img/drink/chai.png",
      description:
        "Warm, aromatic flavor profile with notes of spice and sweetness, often enjoyed as a comforting and invigorating beverage",
      quantity: 0,
    },
    {
      name: "Buckwheat Tea",
      price: 2100,
      ordered: false,
      image: "./img/drink/buckwheat-tea.png",
      description:
        "Rich in nutrients such as protein, fiber, vitamins, and minerals, making it a popular choice for healthy diets",
      quantity: 0,
    },
    {
      name: "Chamomile Tea",
      price: 2100,
      ordered: false,
      image: "./img/drink/Chamomile-tea.png",
      description: "Chamomile tea has a delicate, floral flavor with subtle hints of apple and a mildly sweet taste",
      quantity: 0,
    },
    {
      name: "Mulled Tea",
      price: 3000,
      ordered: false,
      image: "./img/drink/mulled-tea.png",
      description:
        "Mulled tea made with cinnamon, cloves, citrus peel, and sweeteners like honey or sugar, creating a flavorful and aromatic drink",
      quantity: 0,
    },
  ]);

  const [juices, setJuices] = useState([
    {
      name: "Apple Juice",
      price: 2000,
      ordered: false,
      image: "./img/drink/apple-juice.png",
      description: "A refreshing beverage made by pressing or extracting the juice from ripe apples.",
      quantity: 0,
    },
    {
      name: "Orange Juice",
      price: 2000,
      ordered: false,
      image: "./img/drink/orange-juice.png",
      description: "Tangy and refreshing beverage made from the juice of freshly squeezed oranges.",
      quantity: 0,
    },
    {
      name: "Grape Juice",
      price: 2000,
      ordered: false,
      image: "./img/drink/grape-juice.png",
      description: "A sweet and flavorful beverage made from the juice of pressed grapes.",
      quantity: 0,
    },
    {
      name: "Melon Juice",
      price: 2000,
      ordered: false,
      image: "./img/drink/melon-juice.png",
      description:
        "A refreshing beverage made from the juice of ripe melons, such as cantaloupe, honeydew, or watermelon",
      quantity: 0,
    },
    {
      name: "Pineapple Juice",
      price: 2000,
      ordered: false,
      image: "./img/drink/pineapple-juice.png",
      description:
        "Rich in vitamin C, manganese, and other nutrients, offering both nutritional value and a delightful taste.",
      quantity: 0,
    },
  ]);

  const [pastries, setPastries] = useState([
    {
      name: "Apple Tart",
      price: 3200,
      ordered: false,
      image: "./img/food/apple-tart.png",
      description:
        "Indulge in the perfect harmony of crisp, buttery pastry and tender, sweet apple slices with our exquisite apple tart",
      quantity: 0,
    },
    {
      name: "Honey Muffin",
      price: 2800,
      ordered: false,
      image: "./img/food/honey-muffin.png",
      description:
        "Savor the sweetness of golden honey in every bite with our delectable honey muffin. Moist, fluffy, and bursting with a delicate hint of honey.",
      quantity: 0,
    },
    {
      name: "Rolanberry Cheesecake",
      price: 3200,
      ordered: false,
      image: "./img/food/tolanberry-cheesecake.png",
      description:
        "Delicately crafted with creamy cheesecake atop a buttery graham cracker crust offering a perfect balance of sweet and tangy notes.",
      quantity: 0,
    },
    {
      name: "Pineapple Ponzecake",
      price: 3200,
      ordered: false,
      image: "./img/food/pineapple-ponzecake.png",
      description:
        "Creamy richness of cheesecake with the tangy sweetness of pineapple, creating a symphony of flavors that dance on your palate.",
      quantity: 0,
    },
    {
      name: "Coffee Biscuit",
      price: 2500,
      ordered: false,
      image: "./img/food/coffee-biscuit.png",
      description:
        "Crafted with care and precision, each bite offers a perfect balance of buttery texture and aromatic coffee goodness. ",
      quantity: 0,
    },
  ]);

  const [objDrinks, setObjDrinks] = useState([]);

  const [drink, setDrink] = useState([]);
  const [food, setFood] = useState([]);
  const [order, setOrder] = useState({
    cost: 0,
    tipPercent: 0,
  });

  // Add tip to entire order
  const addTip = (e) => {
    let calculateTip = parseInt(Math.round((order.cost * e.target.value) / 100)); // calculation for tipping, done on mouse exit
    if (isNaN(parseInt(e.target.value))) {
      setOrder({ ...order, tipPercent: 0 });
    } else {
      setOrder({ ...order, cost: order.cost + calculateTip, tipPercent: parseInt(e.target.value) }); // updates total cost
    }
  };

  // set drink name and add cost
  const orderDrink = (orderedDrink) => {
    let cost;
    let drinkOrder;

    // coffeeTea.map((drink) => {
    //   if (drink.name === orderedDrink.name) {
    //     setCoffeeTea([...coffeeTea, { ordered: true, quantity: orderedDrink.quantity + 1 }]);
    //   }
    // });

    const d = {
      name: orderedDrink.name,
      total: +1,
    };

    setObjDrinks([(c) => ({ ...c, name: orderedDrink.name, total: +1 })]);

    drinkOrder = setDrink([...drink, orderedDrink.name]);
    cost = setOrder({ ...order, cost: order.cost + orderedDrink.price });
  };

  // set food name and add cost
  const orderFood = (orderedFood) => {
    let cost;
    let foodOrder;

    // set drink name and add cost
    foodOrder = setFood([...food, orderedFood.name]);
    cost = setOrder({ ...order, cost: order.cost + orderedFood.price });

    console.log(foodOrder + " | " + cost);
  };

  function orderedDrinkFood() {
    if (order.cost > 0) {
      if (drink.length > 0 && food.length > 0) {
        return drink + ". For food I'll have a " + food + ". " + " [ $" + order.cost + " dollars ]";
      } else if (drink.length > 0) {
        return drink + " $" + order.cost + " dollars";
      } else if (food.length > 0) {
        return food + ". " + " $" + order.cost + " dollars";
      }
    }
  }

  return (
    <>
      {/* <!-- Navbar start --> */}
      <div className="container-fluid nav-bar">
        {objDrinks.map((drink) => {
          return (<h1 className="text-primary">{drink.name}</h1>), (<>{drink.total}</>);
        })}
        <div className="container">
          <nav className="navbar navbar-light navbar-expand-lg py-3">
            <a href="index.html" class="navbar-brand">
              <p className="text-primary fw-bold mb-0 h1">
                <img className="logo-size" src="#" alt="" />
                Golden
                <span className="text-dark">Gates</span>
              </p>
            </a>
            <button
              className="navbar-toggler py-2 px-3"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
            >
              <span className="fa fa-bars text-primary"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
              <div className="navbar-nav mx-auto"></div>
            </div>
          </nav>
        </div>
      </div>
      {/* <!-- Navbar End --> */}

      {/* <!-- Menu Start --> */}
      <div className="container-fluid menu bg-light py-4">
        <div className="container">
          <div className="text-center wow bounceInUp" data-wow-delay="0.1s">
            <small className="d-inline-block fw-bold text-dark text-uppercase bg-light border border-primary rounded-pill px-4 py-1 mb-3">
              {order.cost > 0 ? "Your Order" : "Our Menu"}
            </small>
            {order.cost > 0 ? (
              <h6>
                {/* I'd like to order a {drink.map((drink) => drink + " + ")} {food.map((food) => food)} */}
                {orderedDrinkFood()}
              </h6>
            ) : (
              ""
            )}
            <h1 className="display-5 mb-5" id="the-menu-items">
              Golden Gates Café
            </h1>
          </div>
          <div className="tab-class text-center">
            <ul
              className="nav nav-pills d-inline-flex justify-content-center mb-5 wow bounceInUp"
              data-wow-delay="0.1s"
            >
              <li className="nav-item p-2">
                <a
                  className="d-flex py-2 mx-2 border border-primary bg-white rounded-pill active"
                  data-bs-toggle="pill"
                  href="#tab-6"
                >
                  <span className="text-dark" style={{ width: "150px" }}>
                    Coffee & Tea
                  </span>
                </a>
              </li>
              <li className="nav-item p-2">
                <a
                  className="d-flex py-2 mx-2 border border-primary bg-white rounded-pill"
                  data-bs-toggle="pill"
                  href="#tab-7"
                >
                  <span className="text-dark" style={{ width: "150px" }}>
                    Juices
                  </span>
                </a>
              </li>
              <li className="nav-item p-2">
                <a
                  className="d-flex py-2 mx-2 border border-primary bg-white rounded-pill"
                  data-bs-toggle="pill"
                  href="#tab-8"
                >
                  <span className="text-dark" style={{ width: "150px" }}>
                    Pastries
                  </span>
                </a>
              </li>
              {/* <li className="nav-item p-2">
                <a
                  className="d-flex py-2 mx-2 border border-primary bg-white rounded-pill"
                  data-bs-toggle="pill"
                  href="#tab-9"
                >
                  <span className="text-dark" style={{ width: "150px" }}>
                    Sandwiches
                  </span>
                </a>
              </li> */}
            </ul>
            <div className="tab-content">
              <div id="tab-6" class="tab-pane fade show p-0 active">
                <div className="row g-4">
                  {coffeeTea.map((orderedDrink) => {
                    return (
                      <div className="col-lg-6 wow bounceInUp" data-wow-delay="0.1s">
                        <div className="menu-item d-flex align-items-center">
                          <img className="flex-shrink-0 img-fluid rounded-circle" src={orderedDrink.image} alt="" />
                          <div className="w-100 d-flex flex-column text-start ps-4">
                            <div className="d-flex justify-content-between border-bottom border-primary pb-2 mb-2">
                              <h4>{orderedDrink.name}</h4>
                              <h4 className="text-primary">
                                ${orderedDrink.price}
                                <button
                                  onClick={() => orderDrink(orderedDrink)}
                                  className="btn btn-sm btn-outline-danger mx-3"
                                >
                                  ORDER
                                </button>
                                <code>{!orderedDrink.quantity ? "" : orderedDrink.quantity}</code>
                              </h4>
                            </div>
                            <p className="mb-0">{orderedDrink.description} </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* cat1 */}

              {/* cat2 */}
              <div id="tab-7" className="tab-pane fade show p-0">
                <div className="row g-4">
                  {juices.map((orderedDrink) => {
                    return (
                      <div className="col-lg-6">
                        <div className="menu-item d-flex align-items-center">
                          <img className="flex-shrink-0 img-fluid rounded-circle" src={orderedDrink.image} alt="" />
                          <div className="w-100 d-flex flex-column text-start ps-4">
                            <div className="d-flex justify-content-between border-bottom border-primary pb-2 mb-2">
                              <h4>{orderedDrink.name}</h4>
                              <h4 className="text-primary">
                                ${orderedDrink.price}
                                <button
                                  onClick={() => orderDrink(orderedDrink)}
                                  className="btn btn-sm btn-outline-danger mx-3"
                                >
                                  ORDER
                                </button>
                              </h4>
                            </div>
                            <p className="mb-0">{orderedDrink.description}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* cat3 */}
              <div id="tab-8" class="tab-pane fade show p-0">
                <div className="row g-4">
                  {pastries.map((orderedFood) => {
                    return (
                      <div className="col-lg-6">
                        <div className="menu-item d-flex align-items-center">
                          <img className="flex-shrink-0 img-fluid rounded-circle" src={orderedFood.image} alt="" />
                          <div className="w-100 d-flex flex-column text-start ps-4">
                            <div className="d-flex justify-content-between border-bottom border-primary pb-2 mb-2">
                              <h4>{orderedFood.name}</h4>
                              <h4 className="text-primary">
                                ${orderedFood.price}
                                <button
                                  onClick={() => orderFood(orderedFood)}
                                  className="btn btn-sm btn-outline-danger mx-3"
                                >
                                  ORDER
                                </button>
                              </h4>
                            </div>
                            <p className="mb-0">{orderedFood.description}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Menu End --> */}

      {/* <!-- Team Start --> */}
      <div class="container-fluid team py-6">
        <div class="container">
          <div class="text-center wow bounceInUp" data-wow-delay="0.1s">
            <small class="d-inline-block fw-bold text-dark text-uppercase bg-light border border-primary rounded-pill px-4 py-1 mb-3">
              Our Team
            </small>
            <h2 class="display-5 mb-5">Check out our dedicated staff</h2>
          </div>
          <div class="row g-4">
            {data.map((member) => {
              return (
                <>
                  <div class="col-lg-3 col-md-6 wow bounceInUp py-2" data-wow-delay="0.1s">
                    <div class="team-item rounded">
                      <img class="img-fluid rounded-top " src={member.image} alt="" />
                      <div class="team-content text-center py-3 bg-dark rounded-bottom">
                        <h4 class="text-primary">{member.name}</h4>
                        <p class="text-white mb-0">{member.role}</p>
                      </div>
                      <div class="team-icon d-flex flex-column justify-content-center m-4">
                        <a
                          class="share btn btn-primary btn-md-square rounded-circle mb-2"
                          href={member.social[0].share}
                          target="_target"
                        >
                          <i class="fas fa-share-alt"></i>
                        </a>
                        <a class="share-link btn btn-primary btn-md-square rounded-circle mb-2" href="">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                        <a class="share-link btn btn-primary btn-md-square rounded-circle mb-2" href="">
                          <i class="fab fa-twitter"></i>
                        </a>
                        <a class="share-link btn btn-primary btn-md-square rounded-circle mb-2" href="">
                          <i class="fab fa-instagram"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </div>
      {/* <!-- Team End --> */}
      <div class="container-fluid footer py-3 my-3 mb-0 bg-light wow bounceInUp" data-wow-delay="0.1s">
        <div class="container">
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="footer-item">
                <h1 class="text-primary">
                  Golden<span class="text-dark">Gates</span>
                  <img className="logo-size" src="./img/golden-gates-logo.png" alt="" />
                </h1>
                <p class="lh-lg mb-4">
                  From classic flavors to innovative creations, our menu offers something for every palate. Crafted with
                  love and passion since 1989.
                </p>
                <div class="footer-icon d-flex">
                  <a class="btn btn-primary btn-sm-square me-2 rounded-circle" href="">
                    <i class="fab fa-facebook-f"></i>
                  </a>
                  <a class="btn btn-primary btn-sm-square me-2 rounded-circle" href="">
                    <i class="fab fa-twitter"></i>
                  </a>
                  <a href="#" class="btn btn-primary btn-sm-square me-2 rounded-circle">
                    <i class="fab fa-instagram"></i>
                  </a>
                  <a href="#" class="btn btn-primary btn-sm-square rounded-circle">
                    <i class="fab fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="footer-item">
                <h4 class="mb-4">Fan Favorites</h4>
                <div class="d-flex flex-column align-items-start">
                  <a class="text-body mb-3" href="#the-menu-items">
                    <i class="fa fa-check text-primary me-2"></i>Chamomile Tea
                  </a>
                  <a class="text-body mb-3" href="#the-menu-items">
                    <i class="fa fa-check text-primary me-2"></i>Melon Juice
                  </a>
                  <a class="text-body mb-3" href="#the-menu-items">
                    <i class="fa fa-check text-primary me-2"></i>Pineapple Juice
                  </a>
                  <a class="text-body mb-3" href="#the-menu-items">
                    <i class="fa fa-check text-primary me-2"></i>Honey Muffin
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="footer-item">
                <h4 class="mb-4">Contact Us</h4>
                <div class="d-flex flex-column align-items-start">
                  <p>
                    <i class="fa fa-map-marker-alt text-primary me-2"></i> 233 Fake Street, USA
                  </p>
                  <p>
                    <i class="fas fa-envelope text-primary me-2"></i>support@goldengates.com
                  </p>
                  <p>
                    <i class="fa fa-clock text-primary me-2"></i> Tuesday & Thursday <br /> 1:00pm - 3:00pm
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="footer-item">
                <h4 class="mb-4">Food Gallery</h4>
                <div class="row g-2">
                  <div class="col-4">
                    <img src="img/menu-01.jpg" class="img-fluid rounded-circle border border-primary p-2" alt="" />
                  </div>
                  <div class="col-4">
                    <img src="img/menu-02.jpg" class="img-fluid rounded-circle border border-primary p-2" alt="" />
                  </div>
                  <div class="col-4">
                    <img src="img/menu-03.jpg" class="img-fluid rounded-circle border border-primary p-2" alt="" />
                  </div>
                  <div class="col-4">
                    <img src="img/menu-04.jpg" class="img-fluid rounded-circle border border-primary p-2" alt="" />
                  </div>
                  <div class="col-4">
                    <img src="img/menu-05.jpg" class="img-fluid rounded-circle border border-primary p-2" alt="" />
                  </div>
                  <div class="col-4">
                    <img src="img/menu-06.jpg" class="img-fluid rounded-circle border border-primary p-2" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer copyRight */}
      <div class="container-fluid copyright bg-dark py-4">
        <div class="container">
          <div class="row">
            <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
              <span class="text-light">
                <a href="#">
                  <i class="fas fa-copyright text-light me-2"></i>Golden Gates
                </a>
                {""} All right reserved.
              </span>
            </div>
            <div class="col-md-6 my-auto text-center text-md-end text-white">
              Developed with React by{" "}
              <a class="border-bottom" href="#">
                George Nikou
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Footer copyRight */}
    </>
  );
}

export default App;
